import { render, staticRenderFns } from "./View.sidebar.vue?vue&type=template&id=45bc0b02&scoped=true&"
import script from "./View.sidebar.vue?vue&type=script&lang=js&"
export * from "./View.sidebar.vue?vue&type=script&lang=js&"
import style0 from "./View.sidebar.vue?vue&type=style&index=0&id=45bc0b02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc0b02",
  null
  
)

export default component.exports